import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // Allow temporary auth via ?print_token=xxx (used by server-side Chromium
  // headless when rendering pages for PDF archiving).
  let token = localStorage.getItem("crm_token");
  try {
    const url = new URL(window.location.href);
    const pt = url.searchParams.get("print_token");
    if (pt) token = pt;
  } catch { /* ignore */ }
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/")) {
      localStorage.removeItem("crm_token");
      localStorage.removeItem("crm_user");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
